import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { LeadApiService } from 'src/app/services/api/lead-api.service';
import { TranslateService } from '@ngx-translate/core';
import { TrackingService } from 'src/app/services/tracking.service';
import { environment } from 'src/environments/local/environment';

@Component({
  selector: 'app-tm-email-sent',
  templateUrl: './tm-email-sent.component.html',
  styleUrls: ['./tm-email-sent.component.scss']
})
export class TmEmailSentComponent implements OnInit, OnDestroy {
  email!: string;
  subs = Array<Subscription>();
  success: boolean = false;
  isLoading!: boolean;
  error = '';

  constructor(
    private basicInfoService: BasicInfoService,
    private leadApi: LeadApiService,
    private translateService: TranslateService,
    private trackingService: TrackingService,
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.email = this.basicInfoService.email;
    this.sendEmail();
  }

  sendEmail(): void {
    this.subs.push(
      this.leadApi.tmLeadNotify(this.basicInfoService.leadId).subscribe(() => {
        this.success = true;
        this.error = '';
        this.isLoading = false;
        
      }, (_error: any) => {
        this.error = `${this.translateService.instant('telemarketing.emailSent.error')}`;
        this.isLoading = false;
      }
      )
    );
    this.trackPageView();
  }

  trackPageView(): void {
    this.trackingService.trackPageView('tm-email-sent');
  }

  tryAgain(): void {
    this.sendEmail();
  }

  atlProTmButton(): void {
    this.trackingService.resetToCorrectCookies({
      utm_source: 'ATL_Pro',
      utm_medium: 'phone',
      utm_campaign: 'tm_april',
    });
    location.href = `${environment.creddoPage}/atl-pro-tm`;
  }
  
  atlNlTmButton(): void {
    this.trackingService.resetToCorrectCookies({
      utm_source: 'ATL_NL',
      utm_medium: 'phone',
      utm_campaign: 'tm_april',
    });
    location.href = `${environment.creddoPage}/atl-nl-tm`;
  }

  ngOnDestroy(): void {
    this.subs.map((s) => s.unsubscribe());
  }
}
